import { strLang } from "./strLang";

export const writeLapsus = () => {
  var month = new Date().getMonth() + 1;
  month = month === 12 ? 0 : month;

  let lapsus = [];
  for (let a = 0; a < 6; a++) {
    lapsus.unshift({
      name: strLang("monthsName")[month],
      pos: month,
      current: a === 1,
    });
    month--;
    if (month < 0) {
      month = 11;
    }
  }
  return lapsus;
};
